import React from "react";
import { useHistory, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

// Material-UI
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
// Gambar
import GambarLogin from "../../../assets/image/backgroundLogin.jpg";
// Components
import Copyright from "../components/Copyright";

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    // backgroundImage: 'url(https://garudanews.id/wp-content/uploads/2019/03/relawan-pmi.jpg)',
    backgroundImage: `url(${GambarLogin})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(10, 4, 0, 4),
    paddingTop: theme.spacing(10),
    display: "flex",
    flexDirection: "column",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  captha: {
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0),
  },
  link: {
      textDecoration: "none"
  }
}));

const BackgroundLogin = ({ classes }) => {
  return (
    <Grid item xs={false} sm={4} md={7} className={classes.image} component="section"/>
  );
};

const FormLogin = ({ classes }) => {
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    console.log("registrasi", data)
    if (data.email === "user1@unj.ac.id") {
      return (
        Swal.fire({
          icon: "success",
          title: "Password Berhasil di Reset!",
          text: "Silahkan cek email kamu ya ^_^",
        }),
        history.push('/')
      );
    } else {
      return Swal.fire({
        icon: "error",
        title: "Email Tidak Terdaftar",
        text: "Email yang anda masukkan tidak terdaftar pada sistem informasi",
      });
    }
  };

  return (
    <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
      <div className={classes.paper}>
        <Typography component="h1" variant="h5" align="center">
          {"RESET PASSWORD"}
        </Typography>
        <form
          className={classes.form}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="email"
            name="email"
            inputRef={register({ required: true })}
            label="Email"
            type="email"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            autoFocus
          />
          <Button
            className={classes.submit}
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            fullWidth
          >
            {"KIRIM"}
          </Button>
          <Box mt={1} mb={4}>
            <Link to="/" className={classes.link}>
              <Button size="large" color="primary" variant="outlined" fullWidth>
                {"Kembali Login"}
              </Button>
            </Link>
          </Box>
          <Box mt={3}>
            <Copyright />
          </Box>
        </form>
      </div>
    </Grid>
  );
};

const LupaPassword = () => {
  const classes = useStyle();
  return (
    <section id="lupa-password">
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <FormLogin classes={classes} />
        <BackgroundLogin classes={classes} />
      </Grid>
    </section>
  );
};
export default LupaPassword;
